var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-footer"},[_c('a',{staticClass:"txt2",attrs:{"href":"https://admins-egypt.com","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t("copyRight"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }